import { Injectable } from '@angular/core';
import { GlobalHelper } from '../Common/global.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AttendanceService {

  constructor(private globalHelper: GlobalHelper, private httpclient: HttpClient) { }

  // STUDENT DAILY ATTENDANCE

  SaveDailyStudentAttendance(ObjAttendance, objList): Observable<any> {

    let formData = new FormData();
    formData.append("ObjAttendance", ObjAttendance);
    formData.append("objList", objList);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'StudentAttendance/SaveDailyStudentAttendance', formData);
  }
  

  GetDailyStudentAttendance(strdata: any): Observable<any> {
    let data = 'objDailyAttendance=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'StudentAttendance/GetDailyStudentAttendance?' + encodeURI(data), { headers: reqHeader });
  }

  // STUDENT MONTHLY ATTENDANCE

  SaveMonthlyStudentAttendance(ObjAttendance, objList): Observable<any> {

    let formData = new FormData();
    formData.append("ObjAttendance", ObjAttendance);
    formData.append("objList", objList);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'StudentAttendance/SaveMonthlyStudentAttendance', formData);
  }


  GetMonthlyStudentAttendance(strdata: any): Observable<any> {
    let data = 'objMonthlyAttendance=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'StudentAttendance/GetMonthlyStudentAttendance?' + encodeURI(data), { headers: reqHeader });
  }
  
   // CONSOLIDATED ATTENDANCE  

   GetAttendanceMonthlyReport(strdata: any): Observable<any> {
    let data = 'objMonthlyAttendance=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'StudentAttendance/GetAttendanceMonthlyReport?' + encodeURI(data), { headers: reqHeader });
  }

  GetAttendanceSummaryReport(strdata: any): Observable<any> {
    let data = 'objMonthlyAttendance=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'StudentAttendance/GetAttendanceSummaryReport?' + encodeURI(data), { headers: reqHeader });
  }

  GetConsolidatedDailyStudentAttendance(strdata: any): Observable<any> {
    let data = 'AttendanceDate=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'StudentAttendance/GetConsolidatedDailyStudentAttendance?' + encodeURI(data), { headers: reqHeader });
  }
  
}
